export default __webpack_public_path__ + "static/media/automation-ball-small.314e5120.jpg";